<template>
  <div>
    <small v-if="dt" style="margin-right: 1em">
      {{ formatDate(dt) }}
    </small>
    <div style="display: block; width: 100%; height: 0.15em;"></div>
    <button
      v-if="showButton"
      class="btn-plain btn-small"
      v-on:click="verifySignature()"
    >
      <i class="fa-wrapper fa fa-lock pad-right success"></i>
      Verify
    </button>
    <i
      class="fa-wrapper fa pad-right"
      v-bind:class="[iconClass, textClass]"
    ></i>
    <!-- The message text (for all cases) -->
    <span v-bind:class="['strong', textClass]">
      {{ message }}
    </span>
  </div>
</template>
<style>
.info-icon {
  color: #2972fa;
}
</style>
<script>
import { authHTTP } from "@/services/axios.service";
import { handleError } from "@/functions/handleError.function";
import { DateTimeFormatter } from "@/functions/dateTimeFormat.function";

export default {
  name: "signature-status",
  props: ["signature", "dt", "role", "module"],
  data: function() {
    return {
      isValid: undefined,
      showButton: false,
      message: "",
      iconClass: "",
      textClass: ""
    };
  },
  methods: {
    setSignatureStatus() {
      if (this.signature == null) {
        this.showButton = false;
        this.message = "Not Signed";
        this.iconClass = "fa-ban info-icon";
        this.textClass = "info-icon";
      } else {
        this.showButton = true;
        this.message = "";
        this.iconClass = "";
        this.textClass = "";
      }
    },
    verifySignature() {
      this.showButton = false;
      authHTTP
        .get(`/${this.module}/${this.$route.params.id}/sign/`)
        .then(response => {
          if (response.data[this.role] == true) {
            this.isValid = true;
            this.message = "Verified";
            this.iconClass = "fa-certificate";
            this.textClass = "success";
          } else {
            this.isValid = false;
            this.message = "Invalid";
            this.iconClass = "fa-exclamation-triangle";
            this.textClass = "error";
          }
        })
        .catch(function(error) {
          let data = handleError(error);
          this.$store.commit("core/setError", data);
        });
    },
    formatDate(date) {
      return DateTimeFormatter(date);
    }
  },
  watch: {
    signature() {
      this.setSignatureStatus();
    }
  },
  mounted() {
    this.setSignatureStatus();
  }
};
</script>
